import { scrollTo } from '../../../application/typescript/utils/utils';

class FooterPrimary {
  constructor() {
    this._init();
  }

  _init() {
    const btnTop = document.querySelector('.footer-primary__top-page');
    const videoBlock = document.querySelector('.video-full');

    if (btnTop && videoBlock) {
      btnTop.addEventListener('click', () => {
        scrollTo(videoBlock);
      });
    }
  }
}

export const footerPrimary = new FooterPrimary();
